export default [
    'Sample Date Time',
    'SampleDateTime',
]